<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>

      <!--img id="header-s" src="https://i.ibb.co/1J2YTy2/Loyalty-hub-header-s.png" /-->

      <div class="title-page-l header-banner">
        <img
          class="icon-title"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-point.png"
        />
        <p>คะเเนนสะสม</p>
        <h1>{{ info.point  | numFormat('0,000,000') }}</h1>
        <a @click="goto('OrderHistory')" type="submit" class="fixios" style="background-color: transparent; color: white; z-index: 99; top: 5px; position: absolute; right: 80px;"><i  class="material-icons" style="font-size: 2rem; color: white; margin: 2px; vertical-align: middle;">history</i></a><a @click="goto('Cart')" type="submit" class="fixios" style="background-color: transparent; color: white; z-index: 99;position:absolute; top:5px;right:15px;"><i  class="material-icons" style="font-size: 2rem; color: white; margin: 2px; vertical-align: middle;">shopping_cart</i> {{ countCart }} </a>
      </div>
      
      <div class="row ">
        <div style="padding-top:100px;z-index:99;">
          <img
            class="img-profile-product"
            :src="'https://api.loyaltyhub.me/public/' + product.image"
            v-if="product.image != ''"
          />
        </div>
      </div>
      <div class="detail">
  
        <div>
        <span class="name-product">{{ product.name }}</span><br>
        
        <span class="name-price">{{ product.price  | numFormat('0,000,000.00') }} ฿</span>

        <span class="name-loca" v-html="product.description">{{
          product.description
        }}</span>
        </div>

        <div class="card" style="width: 92vw">
            <div class="card-body">
              <h5 class="card-title">เพิ่มสินค้า</h5>
              <p style="text-align: left !important;" class="card-text">{{ product.name }}</p>

              <h5 class="card-title">จำนวน</h5>
              <div class="card-text">
                <div class="form-group">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" @click="divide">-</span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      v-model="quantity"
                      aria-label="0"
                      style="text-align: right"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text" @click="add">+</span>
                    </div>
                  </div>
                </div>
                <div style="display: flex">
                  <h5
                    class="card-title"
                    style="align-content: flex-end; text-color: brown"
                  >
                    ยอดรวม {{ amount  | numFormat('0,000,000.00') }} บาท
                  </h5>
                </div>
              </div>
            </div>
          </div>

      </div>
      <div class="bt">
        <a
         
          @click="confirmOrderProduct"
          type="submit"
          class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
        >
          สั่งซื้อ
        </a>
      </div>
      <div class="bt">
        <a
          @click="goto('Cart')"
          type="submit"
          class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
        >
          ดูตะกร้าสินค้า
        </a>
      </div>

       <div class="bt">
        <a
          @click="goto('Product')"
          type="submit"
          class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
        >
          กลับไปซื้อสินค้าต่อ
        </a>
      </div>

      <div class="footer"></div>

      <modal name="orderConfirm" width="80%" max-height="80%" height="auto">
        <div class="qrModal">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <h5 class="card-title">เพิ่มสินค้า</h5>
              <p style="text-align: left !important;" class="card-text">{{ product.name }}</p>

              <h5 class="card-title">จำนวน</h5>
              <div class="card-text">
                <div class="form-group">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" @click="divide">-</span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      v-model="quantity"
                      aria-label="0"
                      style="text-align: right"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text" @click="add">+</span>
                    </div>
                  </div>
                </div>
                <div style="display: flex">
                  <h5
                    class="card-title"
                    style="align-content: flex-end; text-color: brown"
                  >
                    ยอดรวม {{ amount  | numFormat('0,000,000.00') }} บาท
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center" style="margin-top: 16px;margin-left: -7px;">
        <div class="bt">
          <a
            type="submit"
            @click="cancel('orderConfirm')"
            class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
            >ยกเลิก</a
          >
          </div>
          <div class="bt">
          <a
            type="submit"
            @click="confirmOrderProduct"
            class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
            >ยืนยัน</a
          >
          </div>
        </div>
      </modal>
    </body>
  </html>
</template>
<script>
import Navbar from "./navbar";

//import { DateTimeFunc } from "../libs/constant.js";
// eslint-disable-next-line no-unused-vars
//let expiring = 15 * 60;
export default {
  name: "",
  components: {
    navbar: Navbar,
  },
  computed: {
    /*
    startDate() {
      // alert(JSON.stringify(this.product));
      let ymd = this.product.effective_date.substring(0, 10).split("-");
      //alert(ymd);
      //alert(TH_DATE);
      let month = DateTimeFunc.TH_MONTH(ymd[1]);
      return ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543);
    },
    endDate() {
      let ymd = this.product.expire_date.substring(0, 10).split("-");
      //return "";
      let month = DateTimeFunc.TH_MONTH(ymd[1]);
      return ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543);
    },
    */
    countCart() {
      //console.log("countCart");
      //console.log(this.$store.state.cart.length);
      return this.$store.state.cart.length;
    },
    amount() {
      return this.quantity * this.product.price;
    },
    countdown() {
      return this.expiring;
    },
    info() {
      return this.$store.state.profile;
    },
    product() {
      console.log(this.$route.params);
      ////console.log(this.$store.state.products.indexOf(this.$route.params.productIndex || 0));
      ////console.log(this.$store.state.products[this.$store.state.products.indexOf(this.$route.params.productIndex || 0)]);
      //return this.$store.state.products[this.$store.state.products.indexOf(this.$route.params.productIndex || 0)];
      return this.$store.state.products.filter(item=>{
        console.log(item);
        return item._id == this.$route.params.productIndex ;
      })[0];
      
    },
    productIndex(){
      return this.product._id
    }
  },
  data() {
    return {
      //info: this.$store.state.profile,
      // product: this.$store.state.products[this.$route.query.productIndex || 0],
      //productIndex: null,//this.$store.state.products.indexOf(this.$route.params.productIndex || 0),
      expiring: 2 * 60,
      count: 2 * 60,
      countInterval: null,
      orderCode: null,
      name:
        this.$store.state.profile.firstname + " " + this.$store.state.profile.lastname,
      phone: this.$store.state.profile.phone,
      address: "",
      infoPoint: this.$store.state.profile.point,
      quantity: 1,
    };
  },
  beforeDestroy() {
    clearInterval(this.countInterval);
  },

  methods: {
    add() {
      this.quantity++;
    },
    divide() {
      if (this.quantity > 1) this.quantity--;
    },
    updateProductQuantity(index) {
      if (this.infoPoint != this.$store.state.profile.point) {
        this.$store.dispatch("decreaseProductQuantity", index);
        alert("สำเร็จ");
      }
    },
    _setInterval() {
      ////console.log(this.expiring);
      if (this.expiring <= 0) {
        //clearInterval(this.countInterval);
        //this.$modal.hide("qrCode");
        this.close();
        //alert("TIME OUT");
      } else {
        this.expiring -= 1;
      }
      ////console.log(this.expiring);
      //document.getElementById("progressBar").value = 10 - timeleft;},
    },
    _countdown() {
      //console.log("_countdown");
      //let _self = this;
      this.countInterval = setInterval(this._setInterval, 1000);

      ////console.log(this.countInterval);
    },
    confirmOrderProduct() {
      console.log(
        this.$store.state.cart.findIndex((elem) => {
          //console.log(elem);
          return elem.productID == this.product._id;
        })
      );
      if (
        this.$store.state.cart.findIndex((elem) => {
          return elem.productID == this.product._id;
        }) > -1
      ) {
        this.$store.dispatch("updateCart", {
          payload: {
            productID: this.product._id,
            name: this.product.name,
            price: this.product.price,
            quantity: this.quantity,
            image: this.product.image,
            hubspot_id: this.product.hubspot_id,
            category: this.product.category || "",
            sub_category: this.product.sub_category || "",
            amount: this.product.price * this.quantity,
            custId: localStorage.getItem("custId")
          },
          index: this.$store.state.cart.findIndex((elem) => {
            return elem.productID == this.product._id;
          }),
        });
      } else {
        this.$store.dispatch("add2Cart", {
          productID: this.product._id,
          name: this.product.name,
          price: this.product.price,
          quantity: this.quantity,
          image: this.product.image,
          hubspot_id: this.product.hubspot_id,
          category: this.product.category || "",
          sub_category: this.product.sub_category || "",
          amount: this.product.price * this.quantity,
          custId: localStorage.getItem("custId")
        });
      }
      this.$modal.hide("orderConfirm");
      //console.log(this.$store.state.cart);
    },
    showModal(modalName) {
      this.$modal.show(modalName);
    },
    async redeemGoods() {
      // let response = await this.$store.dispatch("createOrderProduct", {
      //   custId: localStorage.getItem("custId"),
      //   apiKey: localStorage.getItem("apiKey"),
      //   memberId: this.info._id,
      //   productId: this.product._id,
      //   shipping_address: {
      //     name: this.name,
      //     phone: this.phone,
      //     address: this.address,
      //   },
      // });
      // await this.$store.dispatch("checkExistedMember", {
      //   line_id: localStorage.getItem("line_id"),
      //   custId: localStorage.getItem("custId"),
      //   apiKey: localStorage.getItem("apiKey"),
      // });
      // this.updateProductQuantity(this.productIndex);
      // //console.log(response);
      // //if (response.data.code == 0) {
      // this.cancel("redeemGoods");
      //}
    },
    cancel(name) {
      this.$modal.hide(name);
    },
    async closeQr() {
      // await this.$store.dispatch("cancelOrderProduct", {
      //   custId: localStorage.getItem("custId"),
      //   apiKey: localStorage.getItem("apiKey"),
      //   memberId: this.info._id,
      //   productId: this.product._id,
      //   memberProductId: this.$store.state.redeem.temp.data._id,
      // });
      // this.$modal.hide("qrCode");
      // clearInterval(this.countInterval);
      this.close();
    },
    async close() {
      this.$modal.hide("qrCode");
      clearInterval(this.countInterval);
      await this.$store.dispatch("checkExistedMember", {
        line_id: localStorage.getItem("line_id"),
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
      });
      this.updateProductQuantity(this.productIndex);
    },
    goto(page) {
      ////console.log(page);
      this.$router.push({
        name: page,
        /*query: {
          apiKey: localStorage.getItem("apiKey"),
          custId: localStorage.getItem("custId"),
        },*/
      });
    },
  },
  mounted() {
    console.log(this.product);
    clearInterval(this.countInterval);
    if(this.$store.state.cart[
        this.$store.state.cart.findIndex((element) => {
         // //console.log(element);
         // //console.log(this.$store.state.products[this.$route.query.productIndex])
          return (
            element.productID ==
            this.product._id
          );
        })
      ] !== undefined){
    this.quantity =
      this.$store.state.cart[
        this.$store.state.cart.findIndex((element) => {
          //console.log(element);
          return (
            element.productID == this.product._id
          );
        })
      ].quantity 
      }else{
        this.quantity = 1;
        }
  },
};
</script>
<style scoped>
@import "./Css/style.css";
/*
.title-page-l {
  width: 100%;
  top: 20px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: 'Prompt';
  padding-left: 15px;
  margin-left: 12px;
    margin-top: -12px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
  letter-spacing: 2px;
  font-family: 'Prompt';
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;
}
.bg-white {
  background-color: transparent !important;
  border-radius: 10px;
  width: 100%;
  position: relative;
  overflow: visible;
  top: 90px;
}

h1 {
  font-size: 20px;
  margin-top: 12px;
  margin-left: 12px;
}
span.name-loca p {
    text-align: left;
}
p[data-v-21a70f56] {
    font-size: 16px;
    color: #7f8285;
    text-align: left;
     margin-left: 0px;
     margin-top: 0px;

}
.img-profile-product {
    display: block;
    width: 94%;
    float: none;
    margin-left: 10px;
    margin-bottom: 0px;
    border-radius: 10px;
    margin-top: 5px;
}
.name-product {
  font-family: 'Prompt';
  font-weight: bold;
  color: #000000;
  margin-top: 13px;
  font-size: 19px;
}
.name-price {
  font-family: 'Prompt';
  color: #7bc79a;
  padding: 0px 0px 0px 0px;
  margin-top: 3px;
  font-size: 24px;
font-weight: 600;
}
.name-time {
  font-family: 'Prompt';
  color: #85847f96;
  margin-bottom: 0px;
  font-size: 16px;
  margin-left: 13px;
}
.condition {
  font-family: 'Prompt';
  color: #85847f96;
  margin-bottom: 0px;
  font-size: 16px;
  margin-left: 13px;
}
.name-loca {
  font-family: 'Prompt';
  color: #7f828596;
  margin-top: 50px;
  margin-bottom: 0px;
  font-size: 16px;
  margin-left: 13px;
}
.iconpoint {
  display: block;
  margin-right: 3px;
  margin-top: 3px;
  width: 27px;
  height: 27px;
  float: left;
  padding: 3px 3px 3px 3px;
}
.iconpoint-top {
     display: block;
    margin-left: -9px;
    margin-right: 10px;
    margin-top: 7px;
    width: 40px;
    height: 40px;
    float: left;
}
.progress {
  margin-top: 5px;
  margin-right: 2px;
  height: 0.9rem;
  border-radius: 53px;
  width: 270px;
}

.progress-bar {
  background-color: #7bc79a;
  border-radius: 53px;
}
.detail {
  margin-top: 100px;
  padding: 5px 15px 15px 15px;
}
.ifor {
  float: right;
  width: 39px;
  height: 39px;
  margin-top: -10px;
}
.btn-block {
  display: block;
  width: 92%;

  margin-left: auto;
  margin-right: auto;
}
.mt-30 {
  margin-top: 20px;
}
.bt {
  margin-left: 0px;
  margin-right: 0px;
}

.footer {
  margin-bottom: 200px;
}

.qrModal {
  margin-top: 0px;
  display: flex;
  justify-content: center;
}
.qr > img {
  text-align: center;
  display: inline-block;
  padding-left: auto;
  padding-right: auto;
}
.text-center {
  display: flex;
  justify-content: center;
  padding-left: auto;
  padding-right: auto;
  width: 100%;
}
a[type="submit"] {
  margin-left: 17px;
}

.vm--modal {
  top: 10% !important;
  max-height: 90% !important;
  overflow: auto !important;
  position: relative;
    overflow: hidden;
    box-sizing: border-box;
    background-color: white;
    border-radius: 3px;
    box-shadow: 0 20px 60px -2px rgb(27 33 58 / 40%);
    padding-left: 15px !important;
    padding-right: 15px !important;
    padding-bottom: 15px !important;
}
.text-left {
  text-align: left;
}
.bold {
  font-weight: bold;
}
.red {
  color: brown;
}
.row {
    margin-left: 0px!important;
}
.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 45%;
}
input.form-control {
    padding: 5px;
}
.btn{
        -webkit-appearance: none;
-moz-appearance: none;
appearance: none;
}
.fixios{
          -webkit-appearance: none;
-moz-appearance: none;
appearance: none;
background-color: transparent;
}
.btn-accept light-color font-color {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
*/
</style>
